import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/general/Header';
import Footer from './components/general/Footer';
import ScrollToTop from './components/general/ScrollToTop';
import Home from './pages/Home';
import GDPRModal from './components/GDPRModal';
import TopicRoute from './pages/TopicRoute';
import MockInterview from './pages/MockInterview';
import AboutUs from './pages/AboutUs';
import ThankYou from './pages/ThankYou';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <GDPRModal />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path=":topic" element={<TopicRoute />} />
            <Route path="/mock-interview" element={<MockInterview />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
